import { useState, useEffect } from "react";
import traking from "../../lib/event/tracker";
import FilterIcon from "../../assets/img/filter.svg";
import styles from "./index.module.css";
/**
 *
 * @param {{filters:Array}} param0
 * @returns
 */
const ProjectFilter = ({ show, filters, toogleFilter }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.filters} style={{ opacity: show ? 1 : 0 }}>
      <span
        style={{ opacity: isOpen ? 1 : "inherit" }}
        onClick={() => {
          setIsOpen((o) => !o);
          traking({
            eventName: isOpen ? "filterClose" : "filterOpen",
            eventAction: "click",
          });
        }}
      >
        <img src={FilterIcon} alt="filter-icon" />
      </span>

      <div
        className={styles.listFilters}
        style={{ display: isOpen ? "block" : "none" }}
      >
        {filters.map((f, i) => {
          return (
            <div
              key={i}
              className={
                styles.typeFilter + (f.active ? " " + styles.activeFilter : "")
              }
              style={{
                transform: !isOpen ? "translateX(-40vw)" : "translateX(0px)",
              }}
              onClick={() => {
                toogleFilter(i);
                traking({
                  eventName: "filterSelection",
                  eventAction: "click",
                });
              }}
            >
              {f.name}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProjectFilter;
